import { MOBILE_PAGES } from '../utils';
import { Categories } from './Categories';
import { Doctor } from './Doctor';
import { Message } from './Message';
import { Main } from './Main';
import { SubLocation } from './Location';
import { Managers } from './Managers';

export default {
  [MOBILE_PAGES.INDEX]: Main,
  [MOBILE_PAGES.CATEGORIES]: Categories,
  [MOBILE_PAGES.DOCTOR_PAGE]: Doctor,
  [MOBILE_PAGES.MESSAGE_PAGE]: Message,
  // [MOBILE_PAGES.LOCATIONS_PAGE]: Locations,
  [MOBILE_PAGES.MANAGERS_PAGE]: Managers,
  [MOBILE_PAGES.LOCATION_PAGE]: SubLocation
};
